import script from "./NbFamousOwner.vue?vue&type=script&setup=true&lang=js"
export * from "./NbFamousOwner.vue?vue&type=script&setup=true&lang=js"

import "./NbFamousOwner.vue?vue&type=style&index=0&id=3d6d0445&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6d0445"]])

export default __exports__